import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { toggleModeratorSettings } from '../../../settings/actions.web';
import { getModeratorSettingsVisibility } from '../../../settings/functions.web';
import ModeratorButton from './ModeratorButton';
import { getLocalParticipant, isParticipantModerator } from "../../../base/participants/functions";
import ModeratorSettingsPopup from "../../../settings/components/web/moderator/ModeratorSettingsPopup";
import { isNeedShowElectronOnlyElements } from "../../../base/environment/utils_web";
import { iAmVisitor } from "../../../visitors/functions";
import { getWindowQueryData } from "../../../desktop-picker/functions";
/**
 * Button used for moderator settings.
 *
 * @returns {ReactElement}
 */
class ModeratorSettingsButton extends Component {
    /**
     * Initializes a new {@code ModeratorSettingsButton} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onEscClick = this._onEscClick.bind(this);
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onClick();
        }
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {MouseEvent} e - Mouse event.
     * @returns {void}
     */
    _onClick(e) {
        const { onModeratorOptionsClick, isOpen } = this.props;
        if (isOpen) {
            e?.stopPropagation();
        }
        onModeratorOptionsClick();
    }
    /**
     * Implements React's {@link Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { visible } = this.props;
        const { isWebVersion } = getWindowQueryData();
        if (!isNeedShowElectronOnlyElements() && !isWebVersion) {
            return (React.createElement("div", { style: {
                    width: '48px',
                    height: '48px',
                    opacity: 0,
                    pointerEvents: 'none',
                } }));
        }
        return visible ? (React.createElement(ModeratorSettingsPopup, null,
            React.createElement("div", { onClick: this._onClick },
                React.createElement(ModeratorButton, null)))) : React.createElement(React.Fragment, null);
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const localParticipant = getLocalParticipant(state);
    const isModerator = isParticipantModerator(localParticipant);
    const { isSupportPreJoinPage } = getWindowQueryData();
    const canShowOnElectron = !iAmVisitor(state) && isSupportPreJoinPage;
    return {
        isOpen: Boolean(getModeratorSettingsVisibility(state)),
        visible: (!isMobileBrowser() && isModerator) || canShowOnElectron,
    };
}
const mapDispatchToProps = {
    onModeratorOptionsClick: toggleModeratorSettings
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(ModeratorSettingsButton));
